module.exports = __webpack_public_path__ + "img/OT201.86bebda.jpg";